// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3hFlo","header":"ReportDetails_header__ZovCn","title":"ReportDetails_title__1GhaA","left":"ReportDetails_left__3I_y7"};